/**
 * Set Swiper v3.6.5 configuration.
 */
const swiper = new Swiper('.swiper-container', {
  spaceBetween: 4,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
});
 

/**
 * LOAD MORE RESULTS
 */

// Shortcircuit variable
let triggered = false;

const getElementOffset = (el) => {
  const rect = el.getBoundingClientRect();

  return {
    top: rect.top + window.pageYOffset,
    left: rect.left + window.pageXOffset,
  };
};

//  Convert a template string into HTML DOM nodes
const stringToHTML = function (str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return doc.body;
};

let allResultsBtn = document.getElementById('show-all-button');
let btnWasClicked = false;

let nextUrl, el, currentPage, pages;

const defineValues = () => {
  // Get URL from the loadmore button
  nextUrl = allResultsBtn.getAttribute('href');

  // Get current page and nr of pages
  el = document.querySelector('input');
  currentPage = parseInt(el.getAttribute('data-current-page'));
  pages = parseInt(el.getAttribute('data-total-pages'));

  allResultsBtn.addEventListener('click', () => {
    btnWasClicked = true;
    ScrollExecute('display');
  });
};

const ScrollExecute = (screen) => {
  if (currentPage < pages) {
    const allResultsBtnOffset = getElementOffset(allResultsBtn);

    // Button position when AJAX call should be made one time
    if (allResultsBtnOffset.top - window.pageYOffset < 800 && triggered == false) {
      // Trigger shortcircuit to ensure AJAX only fires once
      triggered = true;

      // Make ajax call to load more data
      fetch(nextUrl)
        .then((response) => {
          return response.text();
        })

        .then((data) => {
          currentPage += 1;
          // Change next url to previous page + 1
          nextUrl = nextUrl.replace(/page=[0-9]+/, 'page=' + (currentPage + 1));

          const htmlFarmers = stringToHTML(data).querySelector('.shop__farmers__contents').innerHTML;

          // Append data
          const farmersContainer = document.querySelector('#farmers__container');
          farmersContainer.insertAdjacentHTML('beforeend', htmlFarmers);
          triggered = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  } else {
    if (triggered == false) {
      allResultsBtn.parentNode.removeChild(allResultsBtn);
    }
    triggered = true;
  }
};

// window.onload = () => {
//   window.onscroll = () => {
//     if (btnWasClicked) {
//       ScrollExecute();
//     }
//   };
// };

// SHOW RESULTS NAV BUTTONS IF FETCH IS NOT SUPPORTED

if ((navigator.userAgent.indexOf('Opera Mini') || navigator.userAgent.indexOf('IE')) != -1) {
  if (allResultsBtn) {
    document.querySelectorAll('#results-nav').forEach((el) => {
      el.style.display = 'block';
    });
    allResultsBtn.parentNode.removeChild(allResultsBtn);
  }
}

// Add padding if there is a topbar
window.onload = () => {
  if (allResultsBtn) {
    defineValues();
    window.onscroll = () => {
      if (btnWasClicked) {
        ScrollExecute();
      }
    };
  }

  const addPaddingIfTopbar = () => {
    if (document.body.classList.contains("smartbar-inserted")) {
      // Calculate smart bar height and move the content down
      const smartbar = document.querySelector("#smartbar-app");
      const smartbarHeight = window.getComputedStyle(smartbar).height;
      let smartbarPx = 0;
      if (smartbarHeight) smartbarPx = Number(smartbarHeight.split("px")[0]);

      document.body.style.paddingTop = `${smartbarPx}px`;

      // PRODUCT PAGE
      // Move down mobile header
      const mobileHeader = document.querySelector(".shop__product__header");

      if (mobileHeader) {
        const headerTop = window.getComputedStyle(mobileHeader).top;
        let headerTopPx = 0;
        if (headerTop) headerTopPx = Number(headerTop.split("px")[0]);
        mobileHeader.style.top = `${headerTopPx + smartbarPx}px`;
      }
    }
  };
  setTimeout(addPaddingIfTopbar, 2000);
  
   // Show notification (if it exists)
  const shopNotification = document.getElementById('notification');
  const referrer = document.referrer;

  // Show popup only on the first app load
  const shopifyReferrer = referrer.includes('orteat');

  if(shopNotification && !shopifyReferrer) {
    const showNotification = () => {
      shopNotification.classList.add('shop__notification--show');
    }
    setTimeout(showNotification, 2000)
  }
  
};
